import AuthProtectedRoute from './AuthProtectedRoute';

export default AuthProtectedRoute;
